import { Container, useMantineTheme } from "@mantine/core";

import { EVENT_LANDING_MSG } from "_constants";
import type { Event } from "event/types/event.model";
import { Header } from "../components/Header";
import { DEFAULT_WHITE_COLOR } from "../../../_graphic_design";
import "./RegisteredEventHomepageView.css";
import { Header2 } from "../components/Header2";

type RegisteredEventHomepageViewProps = {
  event: Event;
};

const RegisteredEventHomepageView = ({
  event,
}: RegisteredEventHomepageViewProps) => {
  //theme by hook
  const theme = useMantineTheme();
  const registeredEventTextsFontColor =
    event.colors?.registeredEventHomePageText ?? DEFAULT_WHITE_COLOR;
  return (
    <Container className="event-screens h-auto min-h-screen">
      {event.header?.enabled ? <Header2 /> : <Header />}

      <div
        style={{
          color: registeredEventTextsFontColor,
          display: "flex",
          flexDirection: "column",
          fontSize: "14px",
          fontWeight: "bold",
          fontFamily: theme.fontFamily,

          // fontFamily: TEAM_A_FONT_REGULAR,
          paddingBottom: "20px",
          textAlign: "center",
        }}
        id="EventHomePage"
        dangerouslySetInnerHTML={{
          __html: event.labels?.registered_welcome_msg
            ? event.labels.registered_welcome_msg
            : EVENT_LANDING_MSG,
        }}
      />
    </Container>
  );
};

export { RegisteredEventHomepageView };
